import React from 'react';
import About from '../components/About/About';

const AboutPage = () => {
  return (
    <div className="contact-page">
      <About />
    </div>
  );
};

export default AboutPage;